import { proNavigator } from "single-spa/react-app/ProNavigator";

import createSiNavigator from "./navigation/factory";
import type { SiNavigator } from "./navigation/types";

const siNavigator: SiNavigator = createSiNavigator({ navigator: proNavigator });

export default siNavigator;
